import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Hydrate over prerendered HTML when it's present (production, after `postbuild`
// runs prerender.js), otherwise do a fresh client-side render. This lets the
// same bundle work for the CRA dev server AND the prerendered production output.
const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
